export const GET_USER_MODERATION_LIST = 'GET_USER_MODERATION_LIST';//user
export const GET_GROUP_MODERATION_LIST = 'GET_GROUP_MODERATION_LIST';//group
export const GET_REPORT_MODERATION_LIST = 'GET_REPORT_MODERATION_LIST';//user
export const GET_USER_CREDENTIAL_MODERATION_DETAILS = 'GET_USER_CREDENTIAL_MODERATION_DETAILS';//user Credential
export const GET_USER_LOGIN_MODERATION_DETAILS = 'GET_USER_LOGIN_MODERATION_DETAILS';//user login
export const SET_API_PROGRESS = 'SET_API_PROGRESS';//user login
